import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import OpportunityDetail from '@/components/opportunities/show_page.vue'

export default class extends Controller {
  static values = {
    payload: Object
  }

  connect() {
    this.vue = createApp(OpportunityDetail, {
      payload: this.payloadValue || {}
    })

    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
